(function () {
  // localStorage key for persisting shipping addresses
  const STORAGE_KEY = 'shopify_shipping_addresses';

  // Immediately restore from localStorage to prevent flash
  // This runs before DOMContentLoaded to set initial state
  (function restoreInitialState() {
    try {
      const savedData = localStorage.getItem(STORAGE_KEY);
      if (!savedData) return;
      
      const savedAddresses = JSON.parse(savedData);
      const selectedMethod = savedAddresses.selectedMethod;
      if (!selectedMethod) return;
      
      // Set radio button checked state before page renders
      const radios = document.querySelectorAll('input[type="radio"][name="attributes[Shipping method]"]');
      radios.forEach((radio) => {
        if (radio.value === selectedMethod) {
          radio.checked = true;
          radio.defaultChecked = true; // Also set defaultChecked to prevent reset
        }
      });
      
      // Set data attribute on container to indicate initial expanded state
      const container = document.querySelector('[data-cart-shipping-selector]');
      if (container) {
        const hasAddress = selectedMethod === '宅配' 
          ? (savedAddresses.homeDelivery && (savedAddresses.homeDelivery.districtFull || savedAddresses.homeDelivery.road))
          : (savedAddresses.convenienceStoreSelections && savedAddresses.convenienceStoreSelections[selectedMethod]);
        
        if (hasAddress) {
          container.setAttribute('data-has-saved-address', 'true');
        }
      }
    } catch (e) {
      // Ignore errors
    }
  })();

  const saveToLocalStorage = (addresses) => {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(addresses));
    } catch (error) {
      console.warn('Failed to save shipping addresses to localStorage:', error);
    }
  };

  const loadFromLocalStorage = () => {
    try {
      const data = localStorage.getItem(STORAGE_KEY);
      return data ? JSON.parse(data) : null;
    } catch (error) {
      console.warn('Failed to load shipping addresses from localStorage:', error);
      return null;
    }
  };

  const STORE_INDEX = {
    id: 0,
    name: 1,
    city: 2,
    districtFull: 3,
    road: 4,
    address: 5,
    // phone: 6,
  };

  const STORE_SEARCH_INDEX = {
    id: 0,
    name: 1,
    address: 2,
    fileName: 3,
  };

  const METHOD_CONFIG = {
    '7-11': {
      chainKey: 'seven',
      label: '7-11',
      pickerTitle: '更換門市',
      pickerStatus: '7-11 門市查詢',
      addLabel: '+新增 7-11 地址',
      changeLabel: '更換 7-11 門市',
      emptyTitle: '尚未選擇 7-11 門市',
      emptyHint: '點擊上方按鈕後，於右側視窗選擇 7-11 門市。',
    },
    全家: {
      chainKey: 'family',
      label: '全家',
      pickerTitle: '更換門市',
      pickerStatus: '全家 門市查詢',
      addLabel: '+新增 全家 地址',
      changeLabel: '更換 全家 門市',
      emptyTitle: '尚未選擇全家門市',
      emptyHint: '點擊上方按鈕後，於右側視窗選擇全家門市。',
    },
    宅配: {
      label: '宅配',
      pickerTitle: '選擇宅配地址',
      pickerStatus: '請逐級選擇縣市、鄉鎮區與街道',
      addLabel: '+新增宅配地址',
      changeLabel: '更換宅配地址',
      emptyTitle: '尚未選擇宅配地址',
      emptyHint: '點擊上方按鈕後，於右側視窗逐級選擇地址。',
    },
  };

  const CONVENIENCE_STORE_METHODS = ['7-11', '全家'];

  const storeDataPromises = new Map();
  let initFrame = null;
  const isHomeDeliveryMethod = (method) => !CONVENIENCE_STORE_METHODS.includes(method);

  const toHalfWidth = (value) =>
    String(value || '')
      .replace(/[\uFF01-\uFF5E]/g, (char) => String.fromCharCode(char.charCodeAt(0) - 65248))
      .replace(/\u3000/g, ' ');

  const normalizeText = (value) => toHalfWidth(value).replace(/台/g, '臺').replace(/\s+/g, '').toLowerCase();

  const clearChildren = (node) => {
    while (node && node.firstChild) {
      node.removeChild(node.firstChild);
    }
  };

  const getMethodConfig = (method) => METHOD_CONFIG[method] || METHOD_CONFIG['7-11'];

  const loadStoreData = (url) => {
    if (!url) return Promise.reject(new Error('Missing store picker data URL'));

    if (!storeDataPromises.has(url)) {
      const promise = fetch(url, { credentials: 'same-origin' })
        .then((response) => {
          if (!response.ok) throw new Error(`Failed to load store picker data: ${response.status}`);
          return response.json();
        })
        .catch((error) => {
          storeDataPromises.delete(url);
          throw error;
        });

      storeDataPromises.set(url, promise);
    }

    return storeDataPromises.get(url);
  };

  const getStorePickerAssetBaseUrl = (picker) => {
    const explicitBaseUrl = picker && picker.dataset.storePickerAssetsBaseUrl;
    if (explicitBaseUrl) return explicitBaseUrl;

    const sampleUrl =
      (picker && (picker.dataset.storePickerDeliveryUrl || picker.dataset.storePickerSevenUrl || picker.dataset.storePickerFamilyUrl || picker.dataset.storePickerUrl)) ||
      '';
    const cleanUrl = sampleUrl.split('?')[0];

    return cleanUrl.slice(0, cleanUrl.lastIndexOf('/') + 1);
  };

  const buildStorePickerAssetUrl = (picker, fileName) => `${getStorePickerAssetBaseUrl(picker)}${fileName}`;

  const getMethodDataUrl = (picker, method) => {
    if (isHomeDeliveryMethod(method)) {
      return picker.dataset.storePickerDeliveryUrl || picker.dataset.storePickerUrl;
    }

    const config = getMethodConfig(method);

    if (config.chainKey === 'family') {
      return picker.dataset.storePickerFamilyUrl || picker.dataset.storePickerUrl;
    }

    return picker.dataset.storePickerSevenUrl || picker.dataset.storePickerUrl;
  };

  const normalizeMethodData = (method, data) => {
    if (isHomeDeliveryMethod(method)) {
      const delivery = data.delivery || data;

      return {
        delivery: {
          ...delivery,
          roadsByDistrict: delivery.roadsByDistrict || {},
        },
      };
    }

    const config = getMethodConfig(method);
    const chain = data.chains ? data.chains[config.chainKey] : data[config.chainKey] || data;

    return {
      chains: {
        [config.chainKey]: chain,
      },
    };
  };

  const loadMethodData = (picker, method) => loadStoreData(getMethodDataUrl(picker, method)).then((data) => normalizeMethodData(method, data));

  const hasDeliveryRoadsForCity = (delivery, city) => {
    if (!delivery || !city) return false;
    const districts = delivery.districtsByCity ? delivery.districtsByCity[city] || [] : [];

    if (!districts.length) return false;
    if (!delivery.roadsByDistrict) return false;

    return districts.every(([, districtFull]) => Object.prototype.hasOwnProperty.call(delivery.roadsByDistrict, districtFull));
  };

  const hasAllDeliveryRoads = (delivery) => Boolean(delivery && delivery.cities && delivery.cities.every((city) => hasDeliveryRoadsForCity(delivery, city)));

  function buildChoiceButton(text, isActive, onClick) {
    const button = document.createElement('button');
    button.type = 'button';
    button.className = `cart-store-picker__choice${isActive ? ' is-active' : ''}`;
    button.textContent = text;
    button.addEventListener('click', onClick);
    return button;
  }

  function buildEmptyMessage(text) {
    const empty = document.createElement('p');
    empty.className = 'cart-store-picker__empty';
    empty.textContent = text;
    return empty;
  }

  function buildStep(title, options = {}) {
    if (typeof options === 'boolean' || typeof options === 'number') {
      options = { columns: options };
    }

    const { columns = 1, isExpanded = true, summary = '', onToggle = null } = options;
    const step = document.createElement('section');
    step.className = `cart-store-picker__step${isExpanded ? ' is-expanded' : ''}`;

    const heading = document.createElement('button');
    heading.type = 'button';
    heading.className = 'cart-store-picker__step-title';
    heading.setAttribute('aria-expanded', isExpanded ? 'true' : 'false');

    if (typeof onToggle === 'function') {
      heading.addEventListener('click', onToggle);
    }

    const headingContent = document.createElement('span');
    headingContent.className = 'cart-store-picker__step-title-content';

    const headingLabel = document.createElement('span');
    headingLabel.className = 'cart-store-picker__step-label';
    headingLabel.textContent = title;
    headingContent.appendChild(headingLabel);

    if (summary) {
      const headingSummary = document.createElement('span');
      headingSummary.className = 'cart-store-picker__step-summary';
      headingSummary.textContent = summary;
      headingContent.appendChild(headingSummary);
    }

    const headingIcon = document.createElement('span');
    headingIcon.className = 'cart-store-picker__step-icon';
    headingIcon.setAttribute('aria-hidden', 'true');
    headingIcon.textContent = isExpanded ? '−' : '+';

    heading.appendChild(headingContent);
    heading.appendChild(headingIcon);

    // Map columns to class name (1-4)
    const columnClass = {
      1: 'cart-store-picker__step-body cart-store-one-picker__step-body',
      2: 'cart-store-picker__step-body cart-store-two-picker__step-body',
      3: 'cart-store-picker__step-body cart-store-three-picker__step-body',
      4: 'cart-store-picker__step-body',
    }[Math.min(Math.max(columns, 1), 4)] || 'cart-store-picker__step-body';

    const body = document.createElement('div');
    body.className = columnClass;
    body.hidden = !isExpanded;

    step.appendChild(heading);
    step.appendChild(body);

    return { step, body, heading };
  }

  function buildStoreButton(store, onSelect) {
    const button = document.createElement('button');
    button.type = 'button';
    button.className = 'cart-store-picker__store';

    const title = document.createElement('div');
    title.className = 'cart-store-picker__store-title';
    title.textContent = `${store[STORE_INDEX.name]} (${store[STORE_INDEX.id]})`;

    // const meta = document.createElement('div');
    // meta.className = 'cart-store-picker__store-meta';
    // meta.textContent = store[STORE_INDEX.phone] ? `電話 ${store[STORE_INDEX.phone]}` : ' ';

    const address = document.createElement('div');
    address.className = 'cart-store-picker__store-address';
    address.textContent = store[STORE_INDEX.address];

    button.appendChild(title);
    // button.appendChild(meta);
    button.appendChild(address);
    button.addEventListener('click', () => onSelect(store));

    return button;
  }

  function initRoot(root) {
    if (!root || root.dataset.storePickerBound === 'true') return;
    root.dataset.storePickerBound = 'true';

    const detail = root.querySelector('[data-shipping-detail]');
    const optionRows = Array.from(root.querySelectorAll('[data-shipping-option]'));
    const radios = optionRows.map((row) => row.querySelector('input[type="radio"]')).filter(Boolean);
    const triggerButtons = Array.from(root.querySelectorAll('[data-shipping-trigger]'));
    const storeField = root.querySelector('[data-shipping-store-field]');
    const homeField = root.querySelector('[data-shipping-home-field]');
    const hint = root.querySelector('[data-shipping-hint]');

    const selectedStoreCard = root.querySelector('[data-selected-store]');
    const selectedStoreTitle = root.querySelector('[data-selected-store-title]');
    const selectedStoreMeta = root.querySelector('[data-selected-store-meta]');
    const selectedStoreAddress = root.querySelector('[data-selected-store-address]');
    const storeChainInput = root.querySelector('[data-store-chain-input]');
    const storeNameInput = root.querySelector('[data-store-name-input]');
    const storeCodeInput = root.querySelector('[data-store-code-input]');
    const storeAddressInput = root.querySelector('[data-store-address-input]');
    // const storePhoneInput = root.querySelector('[data-store-phone-input]');
    const storeCityInput = root.querySelector('[data-store-city-input]');
    const storeDistrictInput = root.querySelector('[data-store-district-input]');
    const storeRoadInput = root.querySelector('[data-store-road-input]');

    const selectedHomeCard = root.querySelector('[data-selected-home]');
    const selectedHomeTitle = root.querySelector('[data-selected-home-title]');
    const selectedHomeMeta = root.querySelector('[data-selected-home-meta]');
    const selectedHomeAddress = root.querySelector('[data-selected-home-address]');
    const homeDetailInput = root.querySelector('[data-home-detail-input]');
    const deliveryCityInput = root.querySelector('[data-delivery-city-input]');
    const deliveryDistrictInput = root.querySelector('[data-delivery-district-input]');
    const deliveryRoadInput = root.querySelector('[data-delivery-road-input]');
    const deliveryAddressInput = root.querySelector('[data-delivery-address-input]');
    const shippingSummaryInput = root.querySelector('[data-shipping-summary-input]');
    const checkoutCompanyInput = root.querySelector('[data-checkout-company-input]');
    const checkoutAddress1Input = root.querySelector('[data-checkout-address1-input]');
    const checkoutCityInput = root.querySelector('[data-checkout-city-input]');
    const checkoutProvinceInput = root.querySelector('[data-checkout-province-input]');
    const checkoutCountryInput = root.querySelector('[data-checkout-country-input]');
    const cartForm = document.getElementById('cart');
    const checkoutButtons = Array.from(
      document.querySelectorAll('[data-checkout-button], button[name="checkout"][form="cart"], #cart button[name="checkout"]')
    );

    const picker = root.querySelector('[data-store-picker]');
    const pickerPanel = root.querySelector('[data-store-picker-panel]');

    // Helper functions needed before localStorage restoration
    const getMethodConfig = (method) => METHOD_CONFIG[method] || METHOD_CONFIG['7-11'];
    
    const getConvenienceStoreSummary = (method) => {
      return normalizeConvenienceStoreSummary(method, state.convenienceStoreSelections[method]);
    };

    const getHomeSummary = () => {
      const districtFull = deliveryDistrictInput ? deliveryDistrictInput.value.trim() : '';
      const road = deliveryRoadInput ? deliveryRoadInput.value.trim() : '';
      const detailText = homeDetailInput ? homeDetailInput.value.trim() : '';
      const fullAddress = deliveryAddressInput ? deliveryAddressInput.value.trim() : '';
      const city = deliveryCityInput ? deliveryCityInput.value.trim() : '';

      if (!districtFull && !road && !detailText && !fullAddress) return null;

      return {
        city,
        districtFull,
        road,
        detail: detailText,
        fullAddress,
      };
    };

    const syncSelectedStoreCard = (selectedMethod) => {
      if (!selectedStoreCard || !selectedStoreTitle || !selectedStoreMeta || !selectedStoreAddress) return;

      const config = getMethodConfig(selectedMethod);
      const summary = getConvenienceStoreSummary(selectedMethod);

      if (selectedMethod === '宅配' || !summary) {
        selectedStoreCard.classList.add('is-empty');
        selectedStoreTitle.textContent = config.emptyTitle || '尚未選擇門市';
        selectedStoreMeta.textContent = '';
        selectedStoreAddress.textContent = config.emptyHint || '請先選擇門市。';
        return;
      }

      selectedStoreCard.classList.remove('is-empty');
      selectedStoreTitle.textContent = summary.name || config.label;
      selectedStoreMeta.textContent = summary.code ? `門市編號 ${summary.code || '-'}` : '';
      selectedStoreAddress.textContent = summary.address;
    };

    const syncSelectedHomeCard = () => {
      if (!selectedHomeCard || !selectedHomeTitle || !selectedHomeMeta || !selectedHomeAddress) return;

      const summary = getHomeSummary();

      if (!summary || (!summary.districtFull && !summary.fullAddress)) {
        selectedHomeCard.classList.add('is-empty');
        selectedHomeTitle.textContent = METHOD_CONFIG['宅配'].emptyTitle;
        selectedHomeMeta.textContent = '';
        selectedHomeAddress.textContent = METHOD_CONFIG['宅配'].emptyHint;
        return;
      }

      selectedHomeCard.classList.remove('is-empty');
      selectedHomeTitle.textContent = '宅配地址';
      selectedHomeMeta.textContent =
        summary.districtFull && summary.road ? `${summary.districtFull} · ${summary.road}` : summary.districtFull || '';
      selectedHomeAddress.textContent = summary.detail || '';
    };

    const syncActionButtons = (selectedMethod) => {
      optionRows.forEach((row) => {
        const method = row.dataset.shippingValue;
        const button = row.querySelector('[data-shipping-trigger]');
        if (!button) return;

        const config = getMethodConfig(method);
        const summary = method === '宅配' ? getHomeSummary() : getConvenienceStoreSummary(method);
        const hasValue =
          method === '宅配'
            ? !!(summary && ((summary.districtFull && summary.road) || summary.fullAddress))
            : !!summary;

        button.textContent = hasValue ? config.changeLabel : config.addLabel;

        if (method === selectedMethod) {
          button.setAttribute('aria-label', hasValue ? config.changeLabel : config.addLabel);
        }
      });
    };

    const syncHint = (selectedMethod) => {
      if (!hint) return;

      if (!state.expanded) {
        hint.textContent = '';
        hint.classList.remove('is-error');
        return;
      }

      if (state.validationMessage) {
        hint.textContent = state.validationMessage;
        hint.classList.add('is-error');
        return;
      }

      hint.classList.remove('is-error');
      hint.textContent = selectedMethod === '宅配'
        ? '請先逐級選擇地址，再補充門牌、樓層等詳細資訊。'
        : '請先選擇門市；選定後會自動帶入門市名稱、編號與地址。';
    };
    const pickerTitle = root.querySelector('[data-store-picker-title]');
    const pickerStatus = root.querySelector('[data-store-picker-status]');
    const pickerCloseButtons = Array.from(root.querySelectorAll('[data-store-picker-close]'));
    const tabButtons = Array.from(root.querySelectorAll('[data-store-picker-tab-button]'));
    const addressView = root.querySelector('[data-store-picker-view="address"]');
    const nameView = root.querySelector('[data-store-picker-view="name"]');
    const codeView = root.querySelector('[data-store-picker-view="code"]');
    const nameInput = root.querySelector('[data-store-picker-name-input]');
    const codeInput = root.querySelector('[data-store-picker-code-input]');

    if (!detail || !radios.length || !picker || !pickerPanel) return;

    const portalOwner =
      root.closest('#main-cart-footer, .shopify-section, [id]')?.id || root.dataset.cartShippingSelector || 'main-cart-footer';

    picker.dataset.storePickerPortalOwner = portalOwner;

    const existingPortal = document.body.querySelector(
      `[data-store-picker-portal-owner="${portalOwner}"]`
    );

    if (existingPortal && existingPortal !== picker) {
      existingPortal.remove();
    }

    if (picker.parentNode !== document.body) {
      document.body.appendChild(picker);
    }

    const state = {
      expanded: detail.dataset.expanded === 'true',
      pickerOpen: false,
      activeTab: 'address',
      activeMethod: '7-11',
      requestId: 0,
      checkoutSubmitting: false,
      addressSelection: {
        city: '',
        districtFull: '',
        road: '',
      },
      addressAccordionStep: 'city',
      data: null,
      deliveryRoadErrors: {},
      deliverySearchRoadsLoading: false,
      storeFileErrors: {},
      storeSearchErrors: {},
      storeSearchLoading: false,
      loadError: false,
      lastTrigger: null,
      validationMessage: '',
      convenienceStoreSelections: Object.fromEntries(
        CONVENIENCE_STORE_METHODS.map((method) => [method, null])
      ),
    };

    const getSelectedMethod = () => {
      const selectedRadio = radios.find((radio) => radio.checked);
      return selectedRadio ? selectedRadio.value : '7-11';
    };

    const getOptionRow = (method) => optionRows.find((row) => row.dataset.shippingValue === method) || null;

    const getOptionActionButton = (method) => {
      const row = getOptionRow(method);
      return row ? row.querySelector('[data-shipping-trigger]') : null;
    };

    const normalizeConvenienceStoreSummary = (method, summary) => {
      if (!CONVENIENCE_STORE_METHODS.includes(method) || !summary) return null;

      const address = String(summary.address || '').trim();

      if (!address) return null;

      return {
        chain: method,
        name: String(summary.name || '').trim(),
        code: String(summary.code || '').trim(),
        address,
        // phone: String(summary.phone || '').trim(),
        city: String(summary.city || '').trim(),
        districtFull: String(summary.districtFull || '').trim(),
        road: String(summary.road || '').trim(),
      };
    };

    const readConvenienceStoreSummaryFromInputs = () => {
      const method = storeChainInput ? storeChainInput.value.trim() : '';
      return normalizeConvenienceStoreSummary(method, {
        name: storeNameInput ? storeNameInput.value : '',
        code: storeCodeInput ? storeCodeInput.value : '',
        address: storeAddressInput ? storeAddressInput.value : '',
        // phone: storePhoneInput ? storePhoneInput.value : '',
        city: storeCityInput ? storeCityInput.value : '',
        districtFull: storeDistrictInput ? storeDistrictInput.value : '',
        road: storeRoadInput ? storeRoadInput.value : '',
      });
    };

    const writeConvenienceStoreSummaryToInputs = (summary) => {
      if (storeChainInput) storeChainInput.value = summary ? summary.chain : '';
      if (storeNameInput) storeNameInput.value = summary ? summary.name : '';
      if (storeCodeInput) storeCodeInput.value = summary ? summary.code : '';
      if (storeAddressInput) storeAddressInput.value = summary ? summary.address : '';
      // if (storePhoneInput) storePhoneInput.value = summary ? summary.phone : '';
      if (storeCityInput) storeCityInput.value = summary ? summary.city : '';
      if (storeDistrictInput) storeDistrictInput.value = summary ? summary.districtFull : '';
      if (storeRoadInput) storeRoadInput.value = summary ? summary.road : '';
    };

    const setConvenienceStoreSummary = (method, summary) => {
      if (!CONVENIENCE_STORE_METHODS.includes(method)) return;
      state.convenienceStoreSelections[method] = normalizeConvenienceStoreSummary(method, summary);
      // Save to localStorage after updating state
      saveToLocalStorage({
        convenienceStoreSelections: state.convenienceStoreSelections,
        addressSelection: state.addressSelection,
        homeDelivery: state.homeDelivery,
        selectedMethod: getSelectedMethod(),
      });
    };

    const syncConvenienceStoreInputs = (method) => {
      writeConvenienceStoreSummaryToInputs(getConvenienceStoreSummary(method));
    };

    const initialConvenienceStoreSummary = readConvenienceStoreSummaryFromInputs();
    if (initialConvenienceStoreSummary) {
      setConvenienceStoreSummary(initialConvenienceStoreSummary.chain, initialConvenienceStoreSummary);
      writeConvenienceStoreSummaryToInputs(initialConvenienceStoreSummary);
    }

    // Load addresses from localStorage on initialization (sole source of truth)
    const savedAddresses = loadFromLocalStorage();
    if (savedAddresses) {
      let hasRestoredAddress = false;
      let restoredMethod = null;

      // Restore selected shipping method first
      if (savedAddresses.selectedMethod) {
        const methodToRestore = savedAddresses.selectedMethod;
        const radioToRestore = radios.find((radio) => radio.value === methodToRestore);
        if (radioToRestore) {
          radioToRestore.checked = true;
          restoredMethod = methodToRestore;
        }
      }

      // Restore convenience store addresses
      if (savedAddresses.convenienceStoreSelections) {
        Object.keys(savedAddresses.convenienceStoreSelections).forEach((method) => {
          if (CONVENIENCE_STORE_METHODS.includes(method)) {
            const savedSummary = normalizeConvenienceStoreSummary(
              method,
              savedAddresses.convenienceStoreSelections[method]
            );
            if (savedSummary) {
              state.convenienceStoreSelections[method] = savedSummary;
              // Sync to inputs only if this is the currently selected method
              const currentMethod = getSelectedMethod();
              if (currentMethod === method) {
                writeConvenienceStoreSummaryToInputs(savedSummary);
                hasRestoredAddress = true;
              }
            }
          }
        });
      }

      // For home delivery, restore from localStorage
      if (savedAddresses.homeDelivery) {
        const homeSummary = savedAddresses.homeDelivery;
        if (homeSummary && (homeSummary.districtFull || homeSummary.road || homeSummary.fullAddress || homeSummary.detail)) {
          // Update state with complete home delivery data
          state.homeDelivery = homeSummary; // Save complete home delivery object
          state.addressSelection = {
            city: homeSummary.city || '',
            districtFull: homeSummary.districtFull || '',
            road: homeSummary.road || '',
          };
          // Update input fields only if home delivery is currently selected
          const currentMethod = getSelectedMethod();
          if (currentMethod === '宅配') {
            if (deliveryCityInput) deliveryCityInput.value = homeSummary.city || '';
            if (deliveryDistrictInput) deliveryDistrictInput.value = homeSummary.districtFull || '';
            if (deliveryRoadInput) deliveryRoadInput.value = homeSummary.road || '';
            if (homeDetailInput && homeSummary.detail) homeDetailInput.value = homeSummary.detail || '';
            if (deliveryAddressInput && homeSummary.fullAddress) deliveryAddressInput.value = homeSummary.fullAddress || '';
            hasRestoredAddress = true;
          }
        }
      } else if (savedAddresses.addressSelection) {
        // Fallback to old addressSelection format for backward compatibility
        state.addressSelection = { ...state.addressSelection, ...savedAddresses.addressSelection };
      }

      // If we restored an address, expand the detail section and update UI
      // Always expand the detail section, even if no address was restored (show empty state)
      state.expanded = true;
      if (detail) {
        detail.dataset.expanded = 'true';
        detail.removeAttribute('hidden'); // Remove hidden attribute
        detail.hidden = false;
      }
      
      // Show the appropriate field (store or home)
      const selectedMethod = getSelectedMethod();
      const isHomeDelivery = selectedMethod === '宅配';
      
      if (storeField) {
        if (isHomeDelivery) {
          storeField.setAttribute('hidden', '');
        } else {
          storeField.removeAttribute('hidden');
        }
      }
      if (homeField) {
        if (!isHomeDelivery) {
          homeField.setAttribute('hidden', '');
        } else {
          homeField.removeAttribute('hidden');
        }
      }
      
      // Disable/enable inputs based on method
      [storeChainInput, storeNameInput, storeCodeInput, storeAddressInput, storeCityInput, storeDistrictInput, storeRoadInput].forEach((input) => {
        if (input) input.disabled = isHomeDelivery;
      });
      
      [deliveryCityInput, deliveryDistrictInput, deliveryRoadInput, deliveryAddressInput, homeDetailInput].forEach((input) => {
        if (input) input.disabled = !isHomeDelivery;
      });
      
      // Update selected card display (shows empty state or restored address)
      if (isHomeDelivery) {
        syncSelectedHomeCard();
      } else {
        syncSelectedStoreCard(selectedMethod);
      }
      
      // Update action buttons
      syncActionButtons(selectedMethod);
      
      // Update hint
      syncHint(selectedMethod);
    } else {
      // localStorage is empty, but we still need to expand the detail section to show empty state

      // Expand detail section and show empty state
      state.expanded = true;
      if (detail) {
        detail.dataset.expanded = 'true';
        detail.removeAttribute('hidden');
        detail.hidden = false;
      }
      
      // Show appropriate field based on selected method
      const selectedMethod = getSelectedMethod();
      const isHomeDelivery = selectedMethod === '宅配';
      
      if (storeField) {
        if (isHomeDelivery) {
          storeField.setAttribute('hidden', '');
        } else {
          storeField.removeAttribute('hidden');
        }
      }
      if (homeField) {
        if (!isHomeDelivery) {
          homeField.setAttribute('hidden', '');
        } else {
          homeField.removeAttribute('hidden');
        }
      }
      
      // Update UI
      if (isHomeDelivery) {
        syncSelectedHomeCard();
      } else {
        syncSelectedStoreCard(selectedMethod);
      }
      syncActionButtons(selectedMethod);
      syncHint(selectedMethod);
    }

    const setDeliveryAddressValue = () => {
      const parts = [];
      const districtFull = deliveryDistrictInput ? deliveryDistrictInput.value.replace(/\s+/g, '').trim() : '';
      const road = deliveryRoadInput ? deliveryRoadInput.value.trim() : '';
      const detailText = homeDetailInput ? `${homeDetailInput.value.trim()}` : '';
      const previousValue = deliveryAddressInput ? deliveryAddressInput.value.trim() : '';

      if (districtFull) parts.push(districtFull);
      if (road) parts.push(road);
      if (detailText) parts.push(detailText);

      const fullAddress = parts.join('') || previousValue;

      if (deliveryAddressInput) {
        deliveryAddressInput.value = fullAddress;
      }

      return fullAddress;
    };

    const buildShippingPayload = () => {
      const selectedMethod = getSelectedMethod();

      if (selectedMethod === '宅配') {
        const summary = getHomeSummary();
        const address2 = summary ? `${summary.detail || ''}` : '';
        const city = summary ? summary.districtFull : '';
        const province = summary ? summary.city || '' : '';
        const fullAddress = summary ? `${summary.city || ''}${summary.fullAddress || ''}` : '';
        const address1 = summary ? `${city}${summary.road || ''}` : '';

        return {
          summary: fullAddress ? `${selectedMethod} - ${fullAddress}` : '',
          company: selectedMethod,
          address1: address1 || fullAddress,
          address2,
          city,
          province,
          country: fullAddress ? 'TW' : '',
        };
      }

      const summary = getConvenienceStoreSummary(selectedMethod);
      const company = summary && summary.name ? `${selectedMethod} ${summary.name}` : selectedMethod;
      const province = summary ? summary.city || '' : '';
      const city = summary ? summary.districtFull || '' : '';
      const addressPrefix = `${province}${city}`;
      const address1 =
        summary && summary.address
          ? summary.address.startsWith(addressPrefix)
            ? summary.address.slice(addressPrefix.length)
            : summary.address
          : '';
      const summaryParts = [];
      const address2 =
        summary && (summary.name || summary.code)
          ? `${summary.name || selectedMethod}${summary.code ? ` (${summary.code})` : ''}`
          : '';

      if (summary) {
        summaryParts.push(selectedMethod);
        if (summary.name) {
          let storeLabel = summary.name;
          if (summary.code) {
            storeLabel += ` (${summary.code})`;
          }
          summaryParts.push(storeLabel);
        }
        if (summary.address) {
          summaryParts.push(summary.address);
        }
      }

      return {
        summary: summaryParts.join(' - '),
        company,
        address1,
        address2,
        city,
        province,
        country: summary && summary.address ? 'TW' : '',
      };
    };

    const syncShippingPayload = () => {
      const payload = buildShippingPayload();

      if (shippingSummaryInput) shippingSummaryInput.value = payload.summary;
      if (checkoutCompanyInput) checkoutCompanyInput.value = payload.company;
      if (checkoutAddress1Input) checkoutAddress1Input.value = payload.address1;
      if (checkoutCityInput) checkoutCityInput.value = payload.city;
      if (checkoutProvinceInput) checkoutProvinceInput.value = payload.province;
      if (checkoutCountryInput) checkoutCountryInput.value = payload.country;
    };

    // Note: We no longer persist shipping attributes to Shopify Cart Attributes
    // All shipping data is stored in localStorage instead
    const persistShippingAttributes = () => {
      // No-op: localStorage handles persistence
      return Promise.resolve();
    };

    const fetchCartSnapshot = () =>
      fetch(`${routes.cart_url}.js`, {
        credentials: 'same-origin',
        headers: {
          Accept: 'application/json',
        },
      }).then((response) => {
        if (!response.ok) {
          throw new Error(`Failed to load cart snapshot: ${response.status}`);
        }

        return response.json();
      });

    const buildCheckoutParams = () => {
      const payload = buildShippingPayload();
      const params = new URLSearchParams();

      // Only pass shipping address to checkout, not cart attributes
      if (payload.company) {
        params.set('checkout[shipping_address][company]', payload.company);
      }
      if (payload.address1) {
        params.set('checkout[shipping_address][address1]', payload.address1);
      }
      params.set('checkout[shipping_address][address2]', payload.address2);
      if (payload.city) {
        params.set('checkout[shipping_address][city]', payload.city);
      }
      if (payload.province) {
        params.set('checkout[shipping_address][province]', payload.province);
      }
      if (payload.country) {
        params.set('checkout[shipping_address][country]', payload.country);
      }
      // Note: We no longer append cart attributes since we use localStorage
      const selectedMethod = getSelectedMethod();
      params.set('attributes[shipping_method]', selectedMethod);
      return params;
    };

    const buildCheckoutUrl = (cart) => {
      const params = buildCheckoutParams();
      const itemsPath =
        cart && Array.isArray(cart.items)
          ? cart.items
              .filter((item) => item && item.quantity > 0 && item.id)
              .map((item) => `${item.id}:${item.quantity}`)
              .join(',')
          : '';

      const query = params.toString();
      if (!itemsPath) {
        return query ? `${routes.cart_url}?${query}` : routes.cart_url;
      }

      return query ? `${routes.cart_url}/${itemsPath}?${query}` : `${routes.cart_url}/${itemsPath}`;
    };

    const setCheckoutButtonsDisabled = (disabled) => {
      checkoutButtons.forEach((button) => {
        button.disabled = disabled;
        if (disabled) {
          button.setAttribute('aria-disabled', 'true');
        } else {
          button.removeAttribute('aria-disabled');
        }
      });
    };

    const beginCheckout = (event) => {
      // Button disabled state and dedup timestamp share the same 5s window
      const now = Date.now();
      if (state.checkoutSubmitting && (now - state.checkoutSubmitting) < 5000) {
        if (event) event.preventDefault();
        return;
      }

      if (event) {
        event.preventDefault();
        event.stopPropagation();
      }

      if (!validateBeforeCheckout()) {
        updateState();
        return;
      }

      setDeliveryAddressValue();
      syncShippingPayload();
      state.checkoutSubmitting = now;
      setCheckoutButtonsDisabled(true);

      Promise.allSettled([persistShippingAttributes(), fetchCartSnapshot()])
        .then((results) => {
          const cartResult = results[1];
          if (cartResult.status === 'fulfilled') {
            return buildCheckoutUrl(cartResult.value);
          }

          console.error('Cart snapshot load failed:', cartResult.reason);
          return buildCheckoutUrl(null);
        })
        .catch((error) => {
          console.error('Checkout redirect build failed:', error);
          return buildCheckoutUrl(null);
        })
        .then((checkoutUrl) => {
          window.location.assign(checkoutUrl);
        });
    };

    const setHidden = (element, isHidden) => {
      if (!element) return;
      element.hidden = isHidden;

      if (isHidden) {
        element.setAttribute('hidden', 'hidden');
      } else {
        element.removeAttribute('hidden');
      }
    };

    const syncPickerTabs = (selectedMethod) => {
      tabButtons.forEach((button) => {
        const tab = button.dataset.storePickerTabButton;
        // Only hide the "code" tab for 宅配, keep "name" tab available
        button.hidden = selectedMethod === '宅配' && tab === 'code';
      });

      if (selectedMethod === '宅配' && state.activeTab === 'code') {
        state.activeTab = 'address';
      }
    };

    const setActiveTab = (tab) => {
      state.activeTab = tab;

      tabButtons.forEach((button) => {
        const isActive = button.dataset.storePickerTabButton === tab;
        button.classList.toggle('is-active', isActive);
        button.setAttribute('aria-selected', isActive ? 'true' : 'false');
      });

      [addressView, nameView, codeView].forEach((view) => {
        if (!view) return;
        view.hidden = view.dataset.storePickerView !== tab;
      });

      renderActiveView();
    };

    const clearValidationState = () => {
      state.validationMessage = '';

      optionRows.forEach((row) => row.classList.remove('is-error'));
      triggerButtons.forEach((button) => button.classList.remove('is-error'));

      if (selectedStoreCard) selectedStoreCard.classList.remove('is-error');
      if (selectedHomeCard) selectedHomeCard.classList.remove('is-error');
      if (homeDetailInput) homeDetailInput.classList.remove('is-error');
      if (hint) hint.classList.remove('is-error');
    };

    const showValidationError = (message, invalidMethod, options = {}) => {
      const { requireStore = false, requireHomeAddress = false, requireHomeDetail = false } = options;

      state.validationMessage = message;
      state.expanded = true;

      const row = getOptionRow(invalidMethod);
      const actionButton = getOptionActionButton(invalidMethod);

      if (row) row.classList.add('is-error');
      if (actionButton) actionButton.classList.add('is-error');
      if (hint) hint.classList.add('is-error');
      if (requireStore && selectedStoreCard) selectedStoreCard.classList.add('is-error');
      if (requireHomeAddress && selectedHomeCard) selectedHomeCard.classList.add('is-error');
      if (requireHomeDetail && homeDetailInput) homeDetailInput.classList.add('is-error');
    };

    const validateBeforeCheckout = () => {
      clearValidationState();

      const selectedMethod = getSelectedMethod();

      if (selectedMethod === '宅配') {
        setDeliveryAddressValue();

        const homeSummary = getHomeSummary();
        const hasAddressSelection = !!(homeSummary && homeSummary.districtFull && homeSummary.road && homeSummary.fullAddress);
        const hasDetail = !!(homeDetailInput && homeDetailInput.value.trim());

        if (!hasAddressSelection) {
          showValidationError('請先完成宅配地址選擇。', selectedMethod, { requireHomeAddress: true });
          return false;
        }

        if (!hasDetail) {
          showValidationError('請填寫宅配詳細地址，例如門牌、樓層、房號。', selectedMethod, {
            requireHomeDetail: true,
          });
          return false;
        }

        return true;
      }

      const storeSummary = getConvenienceStoreSummary(selectedMethod);

      if (!storeSummary) {
        showValidationError(`請先選擇${selectedMethod}門市。`, selectedMethod, { requireStore: true });
        return false;
      }

      return true;
    };

    const updateState = () => {
      const selectedMethod = getSelectedMethod();
      const isHomeDelivery = selectedMethod === '宅配';

      if (isHomeDelivery) {
        setDeliveryAddressValue();
        writeConvenienceStoreSummaryToInputs(null);
      } else {
        syncConvenienceStoreInputs(selectedMethod);
      }

      optionRows.forEach((row) => {
        row.classList.toggle('is-selected', row.dataset.shippingValue === selectedMethod);
      });

      setHidden(detail, !state.expanded);
      detail.dataset.expanded = state.expanded ? 'true' : 'false';

      setHidden(storeField, !state.expanded || isHomeDelivery);

      setHidden(homeField, !state.expanded || !isHomeDelivery);

      [storeChainInput, storeNameInput, storeCodeInput, storeAddressInput, storeCityInput, storeDistrictInput, storeRoadInput].forEach((input) => {
        if (input) input.disabled = isHomeDelivery;
      });

      [deliveryCityInput, deliveryDistrictInput, deliveryRoadInput, deliveryAddressInput, homeDetailInput].forEach((input) => {
        if (input) input.disabled = !isHomeDelivery;
      });

      syncShippingPayload();
      syncPickerTabs(selectedMethod);
      syncSelectedStoreCard(selectedMethod);
      syncSelectedHomeCard();
      syncHint(selectedMethod);
      syncActionButtons(selectedMethod);
    };

    const closePicker = () => {
      state.pickerOpen = false;
      state.requestId += 1;
      picker.classList.remove('is-open');
      picker.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      document.documentElement.style.overflow = '';

      if (state.lastTrigger && document.contains(state.lastTrigger)) {
        state.lastTrigger.focus();
      }
    };

    const selectStore = (store) => {
      const method = state.activeMethod;

      setConvenienceStoreSummary(method, {
        name: store[STORE_INDEX.name] || '',
        code: store[STORE_INDEX.id] || '',
        address: store[STORE_INDEX.address] || '',
        // phone: store[STORE_INDEX.phone] || '',
        city: store[STORE_INDEX.city] || '',
        districtFull: store[STORE_INDEX.districtFull] || '',
        road: store[STORE_INDEX.road] || '',
      });
      syncConvenienceStoreInputs(method);

      clearValidationState();
      state.expanded = true;
      updateState();
      closePicker();
    };

    const selectHomeRoad = (road) => {
      if (deliveryCityInput) deliveryCityInput.value = state.addressSelection.city || '';
      if (deliveryDistrictInput) deliveryDistrictInput.value = state.addressSelection.districtFull || '';
      if (deliveryRoadInput) deliveryRoadInput.value = road || '';

      state.addressSelection.road = road || '';
      // Save complete home delivery address to localStorage
      const homeSummary = getHomeSummary();
      saveToLocalStorage({
        convenienceStoreSelections: state.convenienceStoreSelections,
        addressSelection: state.addressSelection,
        homeDelivery: homeSummary,
        selectedMethod: getSelectedMethod(),
      });
      clearValidationState();
      state.expanded = true;
      updateState();
      closePicker();

      if (homeDetailInput) {
        homeDetailInput.focus();
      }
    };

    const getChainData = () => {
      if (!state.data) return null;
      const config = getMethodConfig(state.activeMethod);
      return state.data.chains ? state.data.chains[config.chainKey] : null;
    };

    const getActiveAddressData = () => {
      if (!state.data) return null;
      if (state.activeMethod === '宅配') return state.data.delivery || null;
      return getChainData();
    };

    const loadDeliveryRoadsForCity = (city) => {
      const delivery = state.data && state.data.delivery;

      if (!delivery || !city || hasDeliveryRoadsForCity(delivery, city)) {
        return Promise.resolve(delivery);
      }

      const fileName = delivery.roadFilesByCity ? delivery.roadFilesByCity[city] : '';
      if (!fileName) return Promise.resolve(delivery);

      state.deliveryRoadErrors[city] = false;

      return loadStoreData(buildStorePickerAssetUrl(picker, fileName))
        .then((data) => {
          delivery.roadsByDistrict = {
            ...(delivery.roadsByDistrict || {}),
            ...(data.roadsByDistrict || data),
          };
          state.deliveryRoadErrors[city] = false;
          return delivery;
        })
        .catch((error) => {
          state.deliveryRoadErrors[city] = true;
          throw error;
        });
    };

    const loadAllDeliveryRoads = () => {
      const delivery = state.data && state.data.delivery;

      if (!delivery || hasAllDeliveryRoads(delivery)) return Promise.resolve(delivery);

      const cities = (delivery.cities || []).filter((city) => !hasDeliveryRoadsForCity(delivery, city) && !state.deliveryRoadErrors[city]);

      if (!cities.length) return Promise.reject(new Error('Failed to load delivery roads'));

      return Promise.allSettled(cities.map((city) => loadDeliveryRoadsForCity(city))).then((results) => {
        const failed = results.some((result) => result.status === 'rejected');
        if (failed) throw new Error('Failed to load delivery roads');
        return delivery;
      });
    };

    const getStoreCacheKey = (method, city) => `${method}|${city}`;

    const hasStoresForCity = (chainData, city) => {
      if (!chainData || !city) return false;
      if (Array.isArray(chainData.stores)) return true;
      return Boolean(chainData.storesByCity && chainData.storesByCity[city]);
    };

    const mergeStoreFileData = (chainData, data) => {
      if (!chainData) return [];

      const city = data && data.city;
      const stores = data && (data.stores || data);

      if (!city || !Array.isArray(stores)) return [];

      chainData.storesByCity = {
        ...(chainData.storesByCity || {}),
        [city]: stores,
      };

      return stores;
    };

    const loadStoresForCity = (city) => {
      const chainData = getChainData();

      if (!chainData || !city || hasStoresForCity(chainData, city)) {
        return Promise.resolve(chainData);
      }

      const fileName = chainData.storeFilesByCity ? chainData.storeFilesByCity[city] : '';
      if (!fileName) return Promise.resolve(chainData);

      const cacheKey = getStoreCacheKey(state.activeMethod, city);
      state.storeFileErrors[cacheKey] = false;

      return loadStoreData(buildStorePickerAssetUrl(picker, fileName))
        .then((data) => {
          mergeStoreFileData(chainData, data);
          state.storeFileErrors[cacheKey] = false;
          return chainData;
        })
        .catch((error) => {
          state.storeFileErrors[cacheKey] = true;
          throw error;
        });
    };

    const loadStoreSearchIndex = () => {
      const chainData = getChainData();

      if (!chainData || Array.isArray(chainData.stores) || Array.isArray(chainData.searchStores)) {
        return Promise.resolve(chainData);
      }

      const fileName = chainData.searchFile;
      if (!fileName) return Promise.resolve(chainData);

      const cacheKey = `${state.activeMethod}|search`;
      state.storeSearchErrors[cacheKey] = false;

      return loadStoreData(buildStorePickerAssetUrl(picker, fileName))
        .then((data) => {
          chainData.searchFiles = data.files || [];
          chainData.searchStores = data.stores || data;
          state.storeSearchErrors[cacheKey] = false;
          return chainData;
        })
        .catch((error) => {
          state.storeSearchErrors[cacheKey] = true;
          throw error;
        });
    };

    const findStoreInChainData = (chainData, code, address) => {
      const matchesStore = (store) => store && (store[STORE_INDEX.id] === code || store[STORE_INDEX.address] === address);

      if (Array.isArray(chainData.stores)) {
        return chainData.stores.find(matchesStore) || null;
      }

      if (!chainData.storesByCity) return null;

      for (const stores of Object.values(chainData.storesByCity)) {
        const found = stores.find(matchesStore);
        if (found) return found;
      }

      return null;
    };

    const getStoreSearchEntryFileName = (chainData, entry) => {
      const fileReference = entry[STORE_SEARCH_INDEX.fileName];

      if (typeof fileReference === 'number') {
        return (chainData.searchFiles && chainData.searchFiles[fileReference]) || '';
      }

      return fileReference || '';
    };

    const loadStoreForSearchEntry = (entry) => {
      const chainData = getChainData();
      if (!chainData) return Promise.resolve(null);

      const code = entry[STORE_SEARCH_INDEX.id] || '';
      const address = entry[STORE_SEARCH_INDEX.address] || '';
      const existingStore = findStoreInChainData(chainData, code, address);

      if (existingStore) return Promise.resolve(existingStore);

      const fileName = getStoreSearchEntryFileName(chainData, entry);
      if (!fileName) return Promise.resolve(null);

      return loadStoreData(buildStorePickerAssetUrl(picker, fileName)).then((data) => {
        mergeStoreFileData(chainData, data);
        return findStoreInChainData(chainData, code, address);
      });
    };

    const getStoresForSelectedRoad = (chainData) => {
      if (!chainData || !state.addressSelection.districtFull) return [];

      const stores = Array.isArray(chainData.stores)
        ? chainData.stores
        : (chainData.storesByCity && chainData.storesByCity[state.addressSelection.city]) || [];

      return stores.filter((store) => {
        if (store[STORE_INDEX.districtFull] !== state.addressSelection.districtFull) return false;
        if (state.addressSelection.road) {
          return store[STORE_INDEX.road] === state.addressSelection.road;
        }

        return true;
      });
    };

    const validateSavedSelections = (data) => {
      if (!data) return;
      let changed = false;

      // Validate the active convenience store selection only; data is now loaded per method.
      if (CONVENIENCE_STORE_METHODS.includes(state.activeMethod)) {
        const method = state.activeMethod;
        const saved = state.convenienceStoreSelections[method];
        if (!saved) return;

        const config = METHOD_CONFIG[method];
        const chainData = data.chains ? data.chains[config.chainKey] : null;

        if (!chainData) {
          state.convenienceStoreSelections[method] = null;
          changed = true;
          return;
        }

        const cityKnown = saved.city ? (chainData.cities || []).includes(saved.city) : true;
        const storesLoaded = saved.city ? hasStoresForCity(chainData, saved.city) : Boolean(chainData.stores);
        const stillExists = storesLoaded ? Boolean(findStoreInChainData(chainData, saved.code, saved.address)) : cityKnown;

        if (!stillExists) {
          state.convenienceStoreSelections[method] = null;
          changed = true;
        }
      }

      // Validate home delivery address
      if (state.homeDelivery && data.delivery) {
        const delivery = data.delivery;
        const hd = state.homeDelivery;
        const cityValid = hd.city && delivery.cities.includes(hd.city);
        const districts = cityValid ? (delivery.districtsByCity[hd.city] || []) : [];
        const districtValid = hd.districtFull && districts.some(([, full]) => full === hd.districtFull);
        const roadsLoaded = cityValid ? hasDeliveryRoadsForCity(delivery, hd.city) : false;
        const roads = districtValid && roadsLoaded ? (delivery.roadsByDistrict[hd.districtFull] || []) : [];
        const roadValid = hd.road ? !roadsLoaded || roads.includes(hd.road) : true;

        if (!cityValid || !districtValid || !roadValid) {
          state.homeDelivery = null;
          state.addressSelection = { city: '', districtFull: '', road: '' };
          changed = true;
        }
      }

      if (changed) {
        saveToLocalStorage({
          convenienceStoreSelections: state.convenienceStoreSelections,
          addressSelection: state.addressSelection,
          homeDelivery: state.homeDelivery,
          selectedMethod: getSelectedMethod(),
        });

        // Sync inputs for current method
        const currentMethod = getSelectedMethod();
        if (currentMethod === '宅配') {
          syncSelectedHomeCard();
        } else {
          syncConvenienceStoreInputs(currentMethod);
          syncSelectedStoreCard(currentMethod);
        }
        syncActionButtons(currentMethod);
      }
    };

    const toggleAddressAccordionStep = (step) => {
      state.addressAccordionStep = state.addressAccordionStep === step ? null : step;
      renderAddressView();
    };

    const getDefaultAddressAccordionStep = () => {
      if (!state.addressSelection.city) return 'city';
      if (!state.addressSelection.districtFull) return 'district';
      if (!state.addressSelection.road) return 'road';
      if (state.activeMethod === '宅配') return 'road';
      return 'store';
    };

    let renderAddressView = () => {
      if (!addressView) return;
      clearChildren(addressView);

      if (!state.data) {
        addressView.appendChild(buildEmptyMessage(state.loadError ? '地址資料載入失敗，請稍後再試。' : '正在載入地址資料...'));
        return;
      }

      const addressData = getActiveAddressData();

      if (!addressData) {
        addressView.appendChild(buildEmptyMessage('地址資料載入失敗，請稍後再試。'));
        return;
      }

      const cityStep = buildStep('請選擇縣市', { columns: 4 });
      const districtStep = buildStep('請選擇鄉、鎮、市、區', { columns: 3 });
      const roadStep = buildStep(state.activeMethod === '宅配' ? '請選擇街道' : '請選擇街道', { columns: 2 });

      addressData.cities.forEach((city) => {
        cityStep.body.appendChild(
          buildChoiceButton(city, state.addressSelection.city === city, () => {
            state.addressSelection.city = city;
            state.addressSelection.districtFull = '';
            state.addressSelection.road = '';
            renderAddressView();
          })
        );
      });

      if (!addressData.cities.length) {
        cityStep.body.appendChild(buildEmptyMessage('目前沒有可選縣市。'));
      }

      const districts = state.addressSelection.city ? addressData.districtsByCity[state.addressSelection.city] || [] : [];

      if (districts.length) {
        districts.forEach(([district, districtFull]) => {
          districtStep.body.appendChild(
            buildChoiceButton(district, state.addressSelection.districtFull === districtFull, () => {
              state.addressSelection.districtFull = districtFull;
              state.addressSelection.road = '';
              renderAddressView();
            })
          );
        });
      } else {
        districtStep.body.appendChild(buildEmptyMessage('請先選擇縣市。'));
      }

      const roads = state.addressSelection.districtFull ? addressData.roadsByDistrict[state.addressSelection.districtFull] || [] : [];

      if (roads.length) {
        roads.forEach((road) => {
          roadStep.body.appendChild(
            buildChoiceButton(road, state.addressSelection.road === road, () => {
              if (state.activeMethod === '宅配') {
                selectHomeRoad(road);
              } else {
                state.addressSelection.road = road;
                renderAddressView();
              }
            })
          );
        });
      } else if (state.addressSelection.districtFull) {
        roadStep.body.appendChild(buildEmptyMessage('此區域沒有可用街道資料。'));
      } else {
        roadStep.body.appendChild(buildEmptyMessage('請先選擇鄉、鎮、市、區。'));
      }

      addressView.appendChild(cityStep.step);
      addressView.appendChild(districtStep.step);
      addressView.appendChild(roadStep.step);

      if (state.activeMethod === '宅配') {
        return;
      }

      const storeStep = buildStep('請選擇門市', { columns: 1 });
      const stores = getStoresForSelectedRoad(addressData);

      if (stores.length) {
        stores.forEach((store) => {
          storeStep.body.appendChild(buildStoreButton(store, selectStore));
        });
      } else if (state.addressSelection.districtFull) {
        storeStep.body.appendChild(buildEmptyMessage('此篩選條件下沒有門市。'));
      } else {
        storeStep.body.appendChild(buildEmptyMessage('請先完成上方地址選擇。'));
      }

      addressView.appendChild(storeStep.step);
    };

    renderAddressView = () => {
      if (!addressView) return;
      clearChildren(addressView);

      if (!state.data) {
        addressView.appendChild(buildEmptyMessage(state.loadError ? '地址資料載入失敗，請稍後再試。' : '正在載入地址資料...'));
        return;
      }

      const addressData = getActiveAddressData();

      if (!addressData) {
        addressView.appendChild(buildEmptyMessage('地址資料載入失敗，請稍後再試。'));
        return;
      }

      const shouldLoadDeliveryRoads =
        state.activeMethod === '宅配' &&
        state.addressSelection.city &&
        !hasDeliveryRoadsForCity(addressData, state.addressSelection.city) &&
        !state.deliveryRoadErrors[state.addressSelection.city];

      if (shouldLoadDeliveryRoads) {
        loadDeliveryRoadsForCity(state.addressSelection.city)
          .then(() => {
            if (state.pickerOpen && state.activeMethod === '宅配') renderAddressView();
          })
          .catch(() => {
            if (state.pickerOpen && state.activeMethod === '宅配') renderAddressView();
          });
      }

      const storeCityCacheKey = getStoreCacheKey(state.activeMethod, state.addressSelection.city);
      const shouldLoadStoreCity =
        CONVENIENCE_STORE_METHODS.includes(state.activeMethod) &&
        state.addressSelection.city &&
        !hasStoresForCity(addressData, state.addressSelection.city) &&
        !state.storeFileErrors[storeCityCacheKey];

      if (shouldLoadStoreCity) {
        loadStoresForCity(state.addressSelection.city)
          .then(() => {
            if (state.pickerOpen && state.activeMethod !== '宅配') renderAddressView();
          })
          .catch(() => {
            if (state.pickerOpen && state.activeMethod !== '宅配') renderAddressView();
          });
      }

      const cityStep = buildStep('請選擇縣市', {
        isExpanded: state.addressAccordionStep === 'city',
        summary: state.addressSelection.city,
        onToggle: () => toggleAddressAccordionStep('city'),
        columns: 4,
      });
      const districtStep = buildStep('請選擇鄉、鎮、市、區', {
        isExpanded: state.addressAccordionStep === 'district',
        summary: state.addressSelection.districtFull,
        onToggle: () => toggleAddressAccordionStep('district'),
        columns: 3,
      });
      const roadStep = buildStep('請選擇街道', {
        isExpanded: state.addressAccordionStep === 'road',
        summary: state.addressSelection.road,
        onToggle: () => toggleAddressAccordionStep('road'),
        columns: 2,
      });

      addressData.cities.forEach((city) => {
        cityStep.body.appendChild(
          buildChoiceButton(city, state.addressSelection.city === city, () => {
            state.addressSelection.city = city;
            state.addressSelection.districtFull = '';
            state.addressSelection.road = '';
            state.deliveryRoadErrors[city] = false;
            state.storeFileErrors[getStoreCacheKey(state.activeMethod, city)] = false;
            state.addressAccordionStep = 'district';
            renderAddressView();
          })
        );
      });

      if (!addressData.cities.length) {
        cityStep.body.appendChild(buildEmptyMessage('目前沒有可選縣市。'));
      }

      const districts = state.addressSelection.city ? addressData.districtsByCity[state.addressSelection.city] || [] : [];

      if (districts.length) {
        districts.forEach(([district, districtFull]) => {
          districtStep.body.appendChild(
            buildChoiceButton(district, state.addressSelection.districtFull === districtFull, () => {
              state.addressSelection.districtFull = districtFull;
              state.addressSelection.road = '';
              state.addressAccordionStep = 'road';
              renderAddressView();
            })
          );
        });
      } else {
        districtStep.body.appendChild(buildEmptyMessage('請先選擇縣市。'));
      }

      const deliveryRoadsLoading =
        state.activeMethod === '宅配' &&
        state.addressSelection.districtFull &&
        state.addressSelection.city &&
        !hasDeliveryRoadsForCity(addressData, state.addressSelection.city) &&
        !state.deliveryRoadErrors[state.addressSelection.city];
      const deliveryRoadsError =
        state.activeMethod === '宅配' &&
        state.addressSelection.districtFull &&
        state.addressSelection.city &&
        state.deliveryRoadErrors[state.addressSelection.city];
      const roads = state.addressSelection.districtFull ? addressData.roadsByDistrict[state.addressSelection.districtFull] || [] : [];

      if (roads.length) {
        roads.forEach((road) => {
          roadStep.body.appendChild(
            buildChoiceButton(road, state.addressSelection.road === road, () => {
              if (state.activeMethod === '宅配') {
                selectHomeRoad(road);
              } else {
                state.addressSelection.road = road;
                state.addressAccordionStep = 'store';
                renderAddressView();
              }
            })
          );
        });
      } else if (deliveryRoadsLoading) {
        roadStep.body.appendChild(buildEmptyMessage('正在載入街道資料...'));
      } else if (deliveryRoadsError) {
        roadStep.body.appendChild(buildEmptyMessage('街道資料載入失敗，請稍後再試。'));
      } else if (state.addressSelection.districtFull) {
        roadStep.body.appendChild(buildEmptyMessage('此區域沒有可用街道資料。'));
      } else {
        roadStep.body.appendChild(buildEmptyMessage('請先選擇鄉、鎮、市、區。'));
      }

      addressView.appendChild(cityStep.step);
      addressView.appendChild(districtStep.step);
      addressView.appendChild(roadStep.step);

      if (state.activeMethod === '宅配') {
        return;
      }

      const selectedStoreSummary = getConvenienceStoreSummary(state.activeMethod);
      const storeStep = buildStep('請選擇門市', {
        columns: 1,
        isExpanded: state.addressAccordionStep === 'store',
        summary:
          selectedStoreSummary && selectedStoreSummary.name
            ? `${selectedStoreSummary.name}${selectedStoreSummary.code ? ` (${selectedStoreSummary.code})` : ''}`
            : '',
        onToggle: () => toggleAddressAccordionStep('store'),
      });
      const storeCityLoading =
        state.addressSelection.city &&
        !hasStoresForCity(addressData, state.addressSelection.city) &&
        !state.storeFileErrors[storeCityCacheKey];
      const storeCityError = state.addressSelection.city && state.storeFileErrors[storeCityCacheKey];
      const stores = getStoresForSelectedRoad(addressData);

      if (stores.length) {
        stores.forEach((store) => {
          storeStep.body.appendChild(buildStoreButton(store, selectStore));
        });
      } else if (storeCityLoading) {
        storeStep.body.appendChild(buildEmptyMessage('正在載入門市資料...'));
      } else if (storeCityError) {
        storeStep.body.appendChild(buildEmptyMessage('門市資料載入失敗，請稍後再試。'));
      } else if (state.addressSelection.road) {
        storeStep.body.appendChild(buildEmptyMessage('此條件下沒有可選門市。'));
      } else {
        storeStep.body.appendChild(buildEmptyMessage('請先完成上方地址選擇。'));
      }

      addressView.appendChild(storeStep.step);
    };

    const buildStoreSearchButton = (entry) => {
      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'cart-store-picker__store';

      const title = document.createElement('div');
      title.className = 'cart-store-picker__store-title';
      title.textContent = `${entry[STORE_SEARCH_INDEX.name] || ''} (${entry[STORE_SEARCH_INDEX.id] || ''})`;

      const address = document.createElement('div');
      address.className = 'cart-store-picker__store-address';
      address.textContent = entry[STORE_SEARCH_INDEX.address] || '';

      button.appendChild(title);
      button.appendChild(address);
      button.addEventListener('click', () => {
        loadStoreForSearchEntry(entry)
          .then((store) => {
            if (store) selectStore(store);
          })
          .catch(() => {
            if (pickerStatus) pickerStatus.textContent = '門市資料載入失敗';
          });
      });

      return button;
    };

    const renderSearchResults = (container, results, emptyText, options = {}) => {
      clearChildren(container);

      if (!results.length) {
        container.appendChild(buildEmptyMessage(emptyText));
        return;
      }

      results.forEach((store) => {
        container.appendChild(options.searchIndex ? buildStoreSearchButton(store) : buildStoreButton(store, selectStore));
      });
    };

    const renderNameView = () => {
      if (!nameView) return;

      let form = nameView.querySelector('.cart-store-picker__search');
      let results = nameView.querySelector('.cart-store-picker__results');

      if (!form || !results) {
        clearChildren(nameView);
        form = document.createElement('div');
        form.className = 'cart-store-picker__search';
        if (nameInput) form.appendChild(nameInput);
        results = document.createElement('div');
        results.className = 'cart-store-picker__results';
        nameView.appendChild(form);
        nameView.appendChild(results);
      }

      clearChildren(results);

      if (!state.data) {
        results.appendChild(buildEmptyMessage(state.loadError ? '門市資料載入失敗，請稍後再試。' : '正在載入門市資料...'));
      } else {
        const chainData = getChainData();

        if (!chainData) {
          results.appendChild(buildEmptyMessage('門市資料載入失敗，請稍後再試。'));
        } else {
          const query = normalizeText(nameInput ? nameInput.value : '');

          if (!query) {
            results.appendChild(buildEmptyMessage('請輸入門市名稱或地址。'));
          } else if (Array.isArray(chainData.stores)) {
            const matches = chainData.stores
              .filter((store) => normalizeText(`${store[STORE_INDEX.name]}${store[STORE_INDEX.address]}${store[STORE_INDEX.id]}`).includes(query))
              .slice(0, 80);

            renderSearchResults(results, matches, '找不到符合條件的門市。');
          } else {
            const cacheKey = `${state.activeMethod}|search`;

            if (!Array.isArray(chainData.searchStores)) {
              if (!state.storeSearchLoading && !state.storeSearchErrors[cacheKey]) {
                state.storeSearchLoading = true;
                loadStoreSearchIndex()
                  .then(() => {
                    state.storeSearchLoading = false;
                    if (state.pickerOpen && state.activeTab === 'name' && state.activeMethod !== '宅配') renderNameView();
                  })
                  .catch(() => {
                    state.storeSearchLoading = false;
                    if (state.pickerOpen && state.activeTab === 'name' && state.activeMethod !== '宅配') renderNameView();
                  });
              }

              results.appendChild(buildEmptyMessage(state.storeSearchErrors[cacheKey] ? '門市搜尋資料載入失敗，請稍後再試。' : '正在載入門市搜尋資料...'));
              return;
            }

            const matches = chainData.searchStores
              .filter((store) =>
                normalizeText(
                  `${store[STORE_SEARCH_INDEX.name]}${store[STORE_SEARCH_INDEX.address]}${store[STORE_SEARCH_INDEX.id]}`
                ).includes(query)
              )
              .slice(0, 80);

            renderSearchResults(results, matches, '找不到符合條件的門市。', { searchIndex: true });
          }
        }
      }
    };

    const renderCodeView = () => {
      if (!codeView) return;

      let form = codeView.querySelector('.cart-store-picker__search');
      let results = codeView.querySelector('.cart-store-picker__results');

      if (!form || !results) {
        clearChildren(codeView);
        form = document.createElement('div');
        form.className = 'cart-store-picker__search';
        if (codeInput) form.appendChild(codeInput);
        results = document.createElement('div');
        results.className = 'cart-store-picker__results';
        codeView.appendChild(form);
        codeView.appendChild(results);
      }

      clearChildren(results);

      if (!state.data) {
        results.appendChild(buildEmptyMessage(state.loadError ? '門市資料載入失敗，請稍後再試。' : '正在載入門市資料...'));
      } else {
        const chainData = getChainData();
        const query = normalizeText(codeInput ? codeInput.value : '');

        if (!chainData) {
          results.appendChild(buildEmptyMessage('門市資料載入失敗，請稍後再試。'));
        } else if (!query) {
          results.appendChild(buildEmptyMessage('請輸入門市編號。'));
        } else if (Array.isArray(chainData.stores)) {
          const matches = chainData.stores
            .filter((store) => normalizeText(store[STORE_INDEX.id]).includes(query))
            .slice(0, 80);

          renderSearchResults(results, matches, '找不到符合條件的門市編號。');
        } else {
          const cacheKey = `${state.activeMethod}|search`;

          if (!Array.isArray(chainData.searchStores)) {
            if (!state.storeSearchLoading && !state.storeSearchErrors[cacheKey]) {
              state.storeSearchLoading = true;
              loadStoreSearchIndex()
                .then(() => {
                  state.storeSearchLoading = false;
                  if (state.pickerOpen && state.activeTab === 'code') renderCodeView();
                })
                .catch(() => {
                  state.storeSearchLoading = false;
                  if (state.pickerOpen && state.activeTab === 'code') renderCodeView();
                });
            }

            results.appendChild(buildEmptyMessage(state.storeSearchErrors[cacheKey] ? '門市搜尋資料載入失敗，請稍後再試。' : '正在載入門市搜尋資料...'));
            return;
          }

          const matches = chainData.searchStores
            .filter((store) => normalizeText(store[STORE_SEARCH_INDEX.id]).includes(query))
            .slice(0, 80);

          renderSearchResults(results, matches, '找不到符合條件的門市編號。', { searchIndex: true });
        }
      }
    };

    const buildDeliveryResultButton = (city, districtFull, road, onSelect) => {
      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'cart-store-picker__store';

      const title = document.createElement('div');
      title.className = 'cart-store-picker__store-title';
      title.textContent = `${city} ${districtFull}`;

      const address = document.createElement('div');
      address.className = 'cart-store-picker__store-address';
      address.textContent = road || '';

      button.appendChild(title);
      if (road) button.appendChild(address);
      button.addEventListener('click', () => onSelect(city, districtFull, road));

      return button;
    };

    const renderHomeDeliveryNameView = () => {
      if (!nameView) return;

      let form = nameView.querySelector('.cart-store-picker__search');
      let results = nameView.querySelector('.cart-store-picker__results');

      if (!form || !results) {
        clearChildren(nameView);
        form = document.createElement('div');
        form.className = 'cart-store-picker__search';
        if (nameInput) form.appendChild(nameInput);
        results = document.createElement('div');
        results.className = 'cart-store-picker__results';
        nameView.appendChild(form);
        nameView.appendChild(results);
      }

      clearChildren(results);

      if (!state.data) {
        results.appendChild(buildEmptyMessage(state.loadError ? '地址資料載入失敗，請稍後再試。' : '正在載入地址資料...'));
      } else {
        const addressData = getActiveAddressData();
        const query = normalizeText(nameInput ? nameInput.value : '');

        if (!query) {
          results.appendChild(buildEmptyMessage('請輸入地址關鍵字。'));
        } else {
          const allRoadsLoaded = hasAllDeliveryRoads(addressData);
          const hasRoadLoadError = (addressData.cities || []).some((city) => state.deliveryRoadErrors[city]);

          if (!allRoadsLoaded) {
            if (!state.deliverySearchRoadsLoading && !hasRoadLoadError) {
              state.deliverySearchRoadsLoading = true;
              loadAllDeliveryRoads()
                .then(() => {
                  state.deliverySearchRoadsLoading = false;
                  if (state.pickerOpen && state.activeMethod === '宅配' && state.activeTab === 'name') renderHomeDeliveryNameView();
                })
                .catch(() => {
                  state.deliverySearchRoadsLoading = false;
                  if (state.pickerOpen && state.activeMethod === '宅配' && state.activeTab === 'name') renderHomeDeliveryNameView();
                });
            }

            results.appendChild(buildEmptyMessage(hasRoadLoadError ? '街道資料載入失敗，請稍後再試。' : '正在載入街道資料...'));
            return;
          }

          const matches = [];
          const seen = new Set();

          addressData.cities.forEach((city) => {
            const districts = addressData.districtsByCity[city] || [];
            districts.forEach(([district, districtFull]) => {
              const roads = addressData.roadsByDistrict[districtFull] || [];
              if (roads.length === 0) {
                const key = `${city}|${districtFull}|`;
                if (!seen.has(key) && normalizeText(`${city}${districtFull}`).includes(query)) {
                  seen.add(key);
                  matches.push({ city, districtFull, road: '' });
                }
              } else {
                roads.forEach((road) => {
                  const key = `${city}|${districtFull}|${road}`;
                  if (!seen.has(key) && normalizeText(`${city}${districtFull}${road}`).includes(query)) {
                    seen.add(key);
                    matches.push({ city, districtFull, road });
                  }
                });
              }
            });
          });

          const limited = matches.slice(0, 80);
          if (!limited.length) {
            results.appendChild(buildEmptyMessage('找不到符合條件的地址。'));
          } else {
            limited.forEach(({ city, districtFull, road }) => {
              results.appendChild(
                buildDeliveryResultButton(city, districtFull, road, (c, d, r) => {
                  state.addressSelection = { city: c, districtFull: d, road: r };
                  if (deliveryCityInput) deliveryCityInput.value = c;
                  if (deliveryDistrictInput) deliveryDistrictInput.value = d;
                  if (deliveryRoadInput) deliveryRoadInput.value = r;

                  const homeSummary = getHomeSummary();
                  saveToLocalStorage({
                    convenienceStoreSelections: state.convenienceStoreSelections,
                    addressSelection: state.addressSelection,
                    homeDelivery: homeSummary,
                    selectedMethod: getSelectedMethod(),
                  });

                  clearValidationState();
                  state.expanded = true;
                  updateState();
                  closePicker();

                  if (homeDetailInput) {
                    homeDetailInput.focus();
                  }
                })
              );
            });
          }
        }
      }
    };

    const renderActiveView = () => {
      if (state.activeTab === 'address') {
        renderAddressView();
        return;
      }

      if (state.activeTab === 'name') {
        if (state.activeMethod === '宅配') {
          renderHomeDeliveryNameView();
        } else {
          renderNameView();
        }
        return;
      }

      renderCodeView();
    };

    let preloadSelectionFromSummary = () => {
      if (state.activeMethod === '宅配') {
        state.addressSelection = {
          city: deliveryCityInput ? deliveryCityInput.value.trim() : '',
          districtFull: deliveryDistrictInput ? deliveryDistrictInput.value.trim() : '',
          road: deliveryRoadInput ? deliveryRoadInput.value.trim() : '',
        };
        return;
      }

      const summary = getConvenienceStoreSummary(state.activeMethod);
      const chainData = getChainData();

      if (!summary || !chainData) {
        state.addressSelection = { city: '', districtFull: '', road: '' };
        return;
      }

      const matchedStore = findStoreInChainData(chainData, summary.code, summary.address);

      state.addressSelection = {
        city: (matchedStore && matchedStore[STORE_INDEX.city]) || summary.city || '',
        districtFull: (matchedStore && matchedStore[STORE_INDEX.districtFull]) || summary.districtFull || '',
        road: (matchedStore && matchedStore[STORE_INDEX.road]) || summary.road || '',
      };
    };

    preloadSelectionFromSummary = () => {
      if (state.activeMethod === '宅配') {
        state.addressSelection = {
          city: deliveryCityInput ? deliveryCityInput.value.trim() : '',
          districtFull: deliveryDistrictInput ? deliveryDistrictInput.value.trim() : '',
          road: deliveryRoadInput ? deliveryRoadInput.value.trim() : '',
        };
        state.addressAccordionStep = getDefaultAddressAccordionStep();
        return;
      }

      const summary = getConvenienceStoreSummary(state.activeMethod);
      const chainData = getChainData();

      if (!summary || !chainData) {
        state.addressSelection = { city: '', districtFull: '', road: '' };
        state.addressAccordionStep = getDefaultAddressAccordionStep();
        return;
      }

      const matchedStore = findStoreInChainData(chainData, summary.code, summary.address);

      state.addressSelection = {
        city: (matchedStore && matchedStore[STORE_INDEX.city]) || summary.city || '',
        districtFull: (matchedStore && matchedStore[STORE_INDEX.districtFull]) || summary.districtFull || '',
        road: (matchedStore && matchedStore[STORE_INDEX.road]) || summary.road || '',
      };
      state.addressAccordionStep = getDefaultAddressAccordionStep();
    };

    const openPicker = (method, triggerButton) => {
      const requestId = state.requestId + 1;
      state.requestId = requestId;
      state.activeMethod = method;
      state.pickerOpen = true;
      state.lastTrigger = triggerButton || null;

      picker.classList.add('is-open');
      picker.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      document.documentElement.style.overflow = 'hidden';

      syncPickerTabs(method);

      const config = getMethodConfig(method);

      if (pickerTitle) {
        pickerTitle.textContent = config.pickerTitle;
      }

      if (pickerStatus) {
        pickerStatus.textContent = config.pickerStatus;
      }

      state.activeTab = 'address';
      if (nameInput) {
        nameInput.value = '';
        nameInput.placeholder = method === '宅配' ? '搜尋縣市、鄉鎮或街道' : '搜尋門市名稱或地址';
      }
      if (codeInput) codeInput.value = '';

      state.data = null;
      state.loadError = false;
      state.deliverySearchRoadsLoading = false;

      loadMethodData(picker, method)
        .then((data) => {
          if (!state.pickerOpen || state.requestId !== requestId || state.activeMethod !== method) return;

          state.data = data;
          state.loadError = false;
          state.deliveryRoadErrors = {};
          state.storeFileErrors = {};
          state.storeSearchErrors = {};
          state.storeSearchLoading = false;

          preloadSelectionFromSummary();

          const selectionDataReady =
            isHomeDeliveryMethod(method) && state.addressSelection.city
              ? loadDeliveryRoadsForCity(state.addressSelection.city).catch(() => null)
              : state.addressSelection.city
                ? loadStoresForCity(state.addressSelection.city).catch(() => null)
                : Promise.resolve();

          // Validate saved selections against current data and clear stale entries
          validateSavedSelections(data);

          setActiveTab('address');
          pickerPanel.focus();

          selectionDataReady.then(() => {
            if (!state.pickerOpen || state.requestId !== requestId || state.activeMethod !== method) return;
            validateSavedSelections(data);
            renderActiveView();
          });
        })
        .catch(() => {
          if (!state.pickerOpen || state.requestId !== requestId || state.activeMethod !== method) return;

          if (pickerStatus) {
            pickerStatus.textContent = method === '宅配' ? '地址資料載入失敗' : '門市資料載入失敗';
          }
          state.data = null;
          state.loadError = true;
          renderActiveView();
        });

      renderActiveView();
    };

    radios.forEach((radio) => {
      radio.addEventListener('change', () => {
        if (state.pickerOpen && getSelectedMethod() !== state.activeMethod) {
          closePicker();
        }

        clearValidationState();
        state.expanded = true;
        updateState();
        // Save selected method to localStorage, but preserve existing homeDelivery data
        // Don't call getHomeSummary() here as it may return null if inputs are empty/hidden
        saveToLocalStorage({
          convenienceStoreSelections: state.convenienceStoreSelections,
          addressSelection: state.addressSelection,
          homeDelivery: state.homeDelivery, // Preserve existing home delivery data
          selectedMethod: getSelectedMethod(),
        });
      });
    });

    triggerButtons.forEach((button) => {
      button.addEventListener('click', () => {
        const row = button.closest('[data-shipping-option]');
        const radio = row ? row.querySelector('input[type="radio"]') : null;

        if (!row || !radio) return;

        if (!radio.checked) {
          radio.checked = true;
          radio.dispatchEvent(new Event('change', { bubbles: true }));
        } else {
          clearValidationState();
          state.expanded = true;
          updateState();
        }

        clearValidationState();
        openPicker(row.dataset.shippingValue, button);
      });
    });

    pickerCloseButtons.forEach((button) => {
      button.addEventListener('click', closePicker);
    });

    tabButtons.forEach((button) => {
      button.addEventListener('click', () => {
        if (button.hidden) return;
        setActiveTab(button.dataset.storePickerTabButton);
      });
    });

    if (nameInput) {
      nameInput.addEventListener('input', () => {
        if (state.activeTab === 'name') {
          if (state.activeMethod === '宅配') {
            renderHomeDeliveryNameView();
          } else {
            renderNameView();
          }
        }
      });
    }

    if (codeInput) {
      codeInput.addEventListener('input', () => {
        if (state.activeTab === 'code') {
          renderCodeView();
        }
      });
    }

    if (homeDetailInput) {
      homeDetailInput.addEventListener('input', () => {
        clearValidationState();
        setDeliveryAddressValue();
        syncShippingPayload();
        syncSelectedHomeCard();
        syncHint(getSelectedMethod());
        syncActionButtons(getSelectedMethod());
        // Save home delivery detail to localStorage
        const homeSummary = getHomeSummary();
        if (homeSummary) {
          saveToLocalStorage({
            convenienceStoreSelections: state.convenienceStoreSelections,
            addressSelection: state.addressSelection,
            homeDelivery: homeSummary,
            selectedMethod: getSelectedMethod(),
          });
        }
      });
    }

    checkoutButtons.forEach((button) => {
      button.addEventListener('click', beginCheckout);
    });

    // Re-enable checkout buttons when the page becomes visible again.
    // Uses multiple events as fallbacks since pageshow alone is unreliable on mobile.
    const recoverCheckoutState = () => {
      if (!state.checkoutSubmitting) return;
      state.checkoutSubmitting = false;
      setCheckoutButtonsDisabled(false);
    };

    window.addEventListener('pageshow', recoverCheckoutState);
    document.addEventListener('visibilitychange', () => {
      if (document.visibilityState === 'visible') recoverCheckoutState();
    });
    window.addEventListener('focus', recoverCheckoutState);

    picker.addEventListener('keydown', (event) => {
      if (!state.pickerOpen || event.key !== 'Escape') return;
      closePicker();
    });

    picker.addEventListener('click', (event) => {
      if (!state.pickerOpen || event.target !== picker) return;
      closePicker();
    });

    updateState();
  }

  function initAll() {
    document.querySelectorAll('[data-cart-shipping-selector]').forEach(initRoot);
  }

  function scheduleInit() {
    if (initFrame) return;

    initFrame = window.requestAnimationFrame(() => {
      initFrame = null;
      initAll();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  if (!window.__cartStorePickerObserver) {
    window.__cartStorePickerObserver = new MutationObserver(scheduleInit);
    window.__cartStorePickerObserver.observe(document.documentElement, {
      childList: true,
      subtree: true,
    });
  }

})();
